import { createContext, useContext, useState } from "react";

const qrScannerContext = createContext();
const useQRScanner = () => useContext(qrScannerContext)

const QRScannerProvider = ({ children }) => {
    const [isQRScanerOn, setIsQRScanerOn] = useState(false)
    const startScanQr = () => {
        setIsQRScanerOn(true)
    }
    const endScanQr = () => {
        setIsQRScanerOn(false)
    }
    return (
        <qrScannerContext.Provider value={{ startScanQr, endScanQr, isQRScanerOn }}>
            {children}
        </qrScannerContext.Provider>
    )
}

export default useQRScanner
export { QRScannerProvider }